import { has, isUndefined } from 'lodash-es'

const transforms = {
  damage: (value = []) => value.join(','),
  ctdiDescriptions: (value = {}) => {
    return JSON.stringify(
      Object.entries(value).reduce((acc, [key, subValue]) => {
        if (isUndefined(subValue)) {
          return acc
        }
        acc[key] = has(transforms, key) ? transforms[key](subValue) : subValue
        return acc
      }, {}),
    )
  },
}

export default formData => {
  return Object.entries(formData).reduce(
    (transformedData, [key, value]) => ({
      ...transformedData,
      [key]: has(transforms, key) ? transforms[key](value) : value,
    }),
    {},
  )
}
